<template>
  <div class="background">
    <v-main :style="style" id="main_content" tabindex="-1">
      <router-view />
    </v-main>
  </div>
</template>

<script lang="ts">
import { useGlobalStore } from '@/stores/global/global.store';
import { mapState } from 'pinia';
import { defineComponent } from 'vue';

export default defineComponent({
  data: () => ({}),
  computed: {
    ...mapState(useGlobalStore, ['rootLoading']),
    style() {
      const style: Record<string, string | number> = {
        paddingTop: 0,
        paddingBottom: '96px',
      };
      if (this.$vuetify.display.lgAndUp) {
        style.marginLeft = '238px';
        style.paddingTop = '64px';
      }
      return style;
    },
  },
  mounted() {
    this.rootLoading = false;
  },
});
</script>

<style lang="scss" scoped>
.background {
  min-height: 100%;
  background-image: linear-gradient(to top, #607c97, #063562);
}

.return-home-link {
  color: #fff !important;
}

.v-icon {
  color: #fff;
  font-size: 2em;
  line-height: 0.6em;
  margin-left: -8px;
}

#alerts {
  position: -webkit-sticky;
  position: sticky;
  top: 4rem;
  z-index: 1;
}
</style>
